import React, { useState } from 'react';
import { Mail, MessageSquare } from 'lucide-react';

const ContactPage = () => {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <h1 className="font-heading font-bold text-3xl text-white mb-2">Contact Us</h1>
      <p className="text-slate-400 mb-8">
        Have a question or feedback? Send us a message and we&apos;ll get back to you.
      </p>
      <div className="rounded-2xl border border-slate-600 bg-slate-800/80 p-6">
        {submitted ? (
          <div className="text-center py-8">
            <p className="text-white font-medium">Thank you for your message.</p>
            <p className="text-slate-400 text-sm mt-2">We&apos;ll respond as soon as we can.</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="contact-name" className="block text-sm font-medium text-slate-300 mb-1">
                Name
              </label>
              <input
                id="contact-name"
                type="text"
                required
                className="w-full px-4 py-2 rounded-xl border border-slate-600 bg-slate-700/50 text-white placeholder-slate-500 focus:ring-2 focus:ring-brand-pink/50 focus:border-brand-pink"
                placeholder="Your name"
              />
            </div>
            <div>
              <label htmlFor="contact-email" className="block text-sm font-medium text-slate-300 mb-1">
                Email
              </label>
              <input
                id="contact-email"
                type="email"
                required
                className="w-full px-4 py-2 rounded-xl border border-slate-600 bg-slate-700/50 text-white placeholder-slate-500 focus:ring-2 focus:ring-brand-pink/50 focus:border-brand-pink"
                placeholder="you@example.com"
              />
            </div>
            <div>
              <label htmlFor="contact-message" className="block text-sm font-medium text-slate-300 mb-1">
                Message
              </label>
              <textarea
                id="contact-message"
                required
                rows={5}
                className="w-full px-4 py-2 rounded-xl border border-slate-600 bg-slate-700/50 text-white placeholder-slate-500 focus:ring-2 focus:ring-brand-pink/50 focus:border-brand-pink"
                placeholder="Your message..."
              />
            </div>
            <button
              type="submit"
              className="w-full flex items-center justify-center gap-2 py-3 rounded-xl bg-brand-pink text-white font-semibold hover:bg-brand-pink-dark"
            >
              <Mail className="h-5 w-5" />
              Send message
            </button>
          </form>
        )}
      </div>
      <div className="mt-8 flex items-center gap-2 text-slate-500 text-sm">
        <MessageSquare className="h-4 w-4" />
        <span>For urgent safety issues, please report from within the app (profile or chat).</span>
      </div>
    </div>
  );
};

export default ContactPage;
